export default __webpack_public_path__ + "static/media/img-30-maldue.640392ca.jpg";